/* eslint-disable global-require */
import { createStore, applyMiddleware, compose as _compose } from 'redux';
import thunkMiddleware from 'redux-thunk';
import withRedux from 'next-redux-wrapper';
import rootReducer from './modules';

const {
  DISABLE_REDUX_LOGGING,
} = process.env;

export const makeStore = (initialState = {}) => {
  const middleware = [thunkMiddleware];

  let compose = _compose;

  if (DISABLE_REDUX_LOGGING === 'false') {
    // Log redux in development environment
    const { createLogger } = require('redux-logger');
    middleware.push(createLogger({
      collapsed: true,
    }));

    compose = require('redux-devtools-extension').composeWithDevTools;
  }

  const store = createStore(rootReducer, initialState,
    compose(applyMiddleware(...middleware)));

  if (__DEVELOPMENT__ && module.hot) {
    module.hot.accept('redux/modules', () => {
      store.replaceReducer(require('redux/modules').default);
    });
  }

  return store;
};

export const reduxPage = (component) => withRedux(makeStore)(component);
/* eslint-enable global-require */
